// The levels are loaded at runtime, never bundled: the player reads the source of their `code` function,
// which esbuild would reprint. A local level is an ES module of scripts/challenges/; a remote one (a url)
// is fetched as text, so that it can also be in the former AMD format: define(function () { return level })

const corsProxyUrl = 'https://explorers.toxicode.fr/cors-proxy?type=js&url='

const urlRegex = /^(http|https):\/\/[^ "]+$/
const esmRegex = /^export\s+default\b/m


function isUrl (text) {
    return urlRegex.test(text)
}


function loadLevels (paths) {
    return Promise.all(paths.map((path) => (isUrl(path) ? loadRemoteLevel(path) : importLocalLevel(path))))
}


// relative to the page base, which is build/<version>/ in prod
function importLocalLevel (path) {
    return importDefault(new URL(`scripts/${path}.js`, document.baseURI).href)
}


async function importDefault (url) {
    const module = await import(url)
    return module.default
}


async function loadRemoteLevel (url) {
    const source = await fetchRemoteSource(url)
    if (esmRegex.test(source)) {
        return importDefault(URL.createObjectURL(new Blob([source], {type: 'text/javascript'})))
    }
    return evaluateAmdLevel(source)
}


async function fetchRemoteSource (url) {
    try {
        return await fetchText(url)
    } catch {
        // the host does not allow CORS: the proxy does
        return fetchText(corsProxyUrl + encodeURIComponent(url))
    }
}


async function fetchText (url) {
    const response = await fetch(url)
    if (!response.ok) {
        throw new Error(`${response.status} ${response.statusText} for ${url}`)
    }
    return response.text()
}


function evaluateAmdLevel (source) {
    let level
    new Function('define', source)((...args) => {
        level = args.at(-1)()
    })
    return level
}



export default {
    isUrl,
    loadLevels
}
